export default {
  data() { return { guideRowMenus: {} } },
  methods: {
    guideRowKey(position) { return `module:${this.idmodule}:row:${position}` },
    guideActionKey(position, action) { return `${this.guideRowKey(position)}:action:${action.id}` },
    guideRef(name) {
      const ref = this.$refs[name]
      const component = Array.isArray(ref) ? ref[0] : ref
      return component && (component.$el || component)
    },
    guideModuleTargets() {
      const targets = []
      if (this.add && this.add.href) {
        const operations = ['new', 'edit'].includes(this.typePage) ? {} : { click: () => this.addLine(), open: () => this.addLine() }
        targets.push(this.guideTarget(`module:${this.idmodule}:add`, () => this.guideRef('guideAdd'), operations, this.add.text || 'Ajouter'))
      }
      const rows = this.$el.querySelectorAll('[data-guide-row-id]')
      Array.from(rows).filter(element => element.closest('[data-guide-module-instance]') === this.$el).forEach((element, index) => {
        const position = index + 1
        const row = Array.isArray(this.datas) && this.datas.find(item => String(item.id) === element.getAttribute('data-guide-row-id'))
        if (!row) return
        // Numbering follows rendered rows, after the current filters, sort and pagination.
        element.setAttribute('data-guide-target', this.guideRowKey(position))
        const select = () => {
          if (!this.axiosParams.params.pagination.showselect) throw new Error('La sélection est désactivée pour ce tableau.')
          if (this.axiosParams.params.pagination.singleselect === false) {
            this.datas.forEach(item => { if (item.id !== row.id) this.$set(item, 'selected', false) })
          }
          this.$set(row, 'selected', true)
          this.selectedItem = this.axiosParams.params.pagination.singleselect === false
            ? [row] : [...this.selectedItem.filter(item => item.id !== row.id), row]
        }
        targets.push(this.guideTarget(this.guideRowKey(position), () => element, { select }, `Ligne ${position}`))
        const actions = (row.action || []).filter(action => !action.params.head && action.params.showInRowMenu !== false)
        if (!actions.length) return
        targets.push(this.guideTarget(`${this.guideRowKey(position)}:menu`,
          () => element.querySelector('[data-guide-row-menu]'),
          { open: () => this.$set(this.guideRowMenus, row.id, true), click: () => this.$set(this.guideRowMenus, row.id, true) }, `Actions de la ligne ${position}`))
        actions.forEach(action => {
          const operations = action.typelink === 'link' ? { click: () => { this.$set(this.guideRowMenus, row.id, false); this.onClickButton(row, action) } } : {}
          targets.push(this.guideTarget(this.guideActionKey(position, action),
            () => this.guideRef(`guideAction-${row.id}-${action.id}`), operations, action.name))
        })
      })
      if (this.selectedItem.length && Array.isArray(this.datas) && this.datas[0]) {
        (this.datas[0].action || []).filter(action => action.params.head).forEach(action => {
          targets.push(this.guideTarget(`module:${this.idmodule}:action:${action.id}`,
            () => this.guideRef(`guideHeadAction-${action.id}`), {}, action.name))
        })
      }
      return targets
    }
  }
}
